import { useToken, useUTLSettingsContext } from "@dexteel/mesf-core";
import { get } from "lodash-es";

export const useDeliveryTicketAlertAccess = () => {
	const {
		state: { settings },
	} = useUTLSettingsContext();
	const { getFirstName } = useToken();
	const userName = getFirstName();

	const FF_CASTER_DE_DELIVERY_TICKET_ALERT = get(
		settings,
		"FF_CASTER_DE_DELIVERY_TICKET_ALERT",
		0,
	);

	const CASTER_DE_DELIVERY_TICKET_ALERT_OFFSET_TIME_IN_MINUTES = get(
		settings,
		"CASTER_DE_DELIVERY_TICKET_ALERT_OFFSET_TIME_IN_MINUTES",
		120,
	);

	const userCleaned = userName.trim();
	const hasAccess =
		!!Number(FF_CASTER_DE_DELIVERY_TICKET_ALERT) &&
		(userCleaned === "Caster1" ||
			userCleaned === "Caster2" ||
			userCleaned === "Admin");

	return {
		hasAccess,
		CASTER_DE_DELIVERY_TICKET_ALERT_OFFSET_TIME_IN_MINUTES,
	};
};
